'use client';

import { useEffect } from 'react';

interface ModalProps {
    id: string;
    isOpen: boolean;
    onClose: () => void;
    children: JSX.Element;
    extendedClassName?: string;
    width?: string;
    height?: string;
}

const Modal = (props: ModalProps) => {
    const { id, isOpen, children, onClose, extendedClassName, width = 'w-[500px]', height = 'h-[auto]' } = props;
    useEffect(() => {
        const dialog = document.getElementById(id) as HTMLDialogElement | null;
        if (isOpen) {
            dialog?.showModal();
        } else {
            dialog?.close();
        }
    }, [isOpen, id]);

    const baseClassName = `modal-box ${width} ${height} flex flex-row max-w-full max-h-full absolute top-8`;
    const modalClassNames = [baseClassName, extendedClassName].filter(Boolean).join(' ');

    return (
        <dialog id={id} className="modal">
            <div className={modalClassNames}>{children}</div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={onClose}>close</button>
            </form>
        </dialog>
    );
};

export default Modal;
